import { DataGrid } from '@/components/DataGrid/DataGrid'
import { AdminLayout } from '@/components/Layout/Layout'
import api from '@/shared/api/api';
import { useFetch } from '@/shared/hooks/useFetch';
import { usePagination } from '@/shared/hooks/usePagination';
import Button from '@/shared/ui/Buttons/Button';
import { DateTimeField, EditButton, ShowButton, TextField } from '@/shared/ui/Fields/Fields';
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';

function ProjectList() {
    const navigate = useNavigate();
    const [totalCount, setTotalCount] = useState<string>("1")
    const {limit, offset, nextPage, prevPage, currPage, setPage, maxPages} = usePagination(
        {rowsNum: 10, totalCount: +(totalCount)}
    );
    const { data: records, headers } = useFetch(
        () => api.projects.getProjectsApiProjectsGet({}),
        [], [limit, offset], { autoRefresh: true, refreshTiming: 80 }
    );
    React.useEffect(()=>{
        setTotalCount(headers?.get("X-Total-Count") || "1")
    }, [headers?.get("X-Total-Count")])

    return (
    <AdminLayout>
        <Button
            style={{alignSelf: "flex-end"}}
            className='text-15 cursor-pointer normal'
            onClick={()=>{
                navigate("/projects/create")
            }}
        >
            Создать проект
        </Button>
        <DataGrid
            title="Проекты"
            records={records}
            nextPage={nextPage}
            prevPage={prevPage}
            currPage={currPage}
            maxPage={maxPages}
            setPage={setPage}
        >
            <TextField key='title' label="Проект" empty='-' />
            <ShowButton key='id' urlPrefix='/projects/manage/' label="" />
            <EditButton key='id' urlPrefix='/projects/update/' label="" />
        </DataGrid>
    </AdminLayout>
  )
}

export default ProjectList;